import Image from 'next/image';

const files = [
  {
    title: 'How To Make AI Work For You',
    size: '29.11.2024',
    source: 'https://media.easy-peasy.ai/static/workshop/Workshop4.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: '20.06.2024',
    source: 'https://media.easy-peasy.ai/static/workshop/Workshop5.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: '15.08.2024',
    source: 'https://media.easy-peasy.ai/static/workshop/Workshop11new.jpeg',
  },
  {
    title: 'How To Make AI Work For You - EASY-PEASY.AI',
    size: '19.04.2024',
    source: 'https://media.easy-peasy.ai/static/workshop/Workshop6.jpeg',
  },
  {
    title: 'How To Make AI Work For You - EASY-PEASY.AI',
    size: '29.11.2024',
    source: '/images/about-us/AI-Workshop13-easy-peasy.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'July 2024',
    source: '/images/about-us/AI-Workshop14-easy-peasy.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'July 2024',
    source: '/images/about-us/AI-Workshop15-easy-peasy.jpeg',
  },

  {
    title: 'How To Make AI Work For You',
    size: 'June 2024',
    source: '/images/about-us/AI-Workshop16-easy-peasy.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'November 2024',
    source: '/images/about-us/AI-Workshop17-easy-peasy.jpeg',
  },
  {
    title: 'Warm Wishes from Japan',
    size: '2024',
    source: '/images/about-us/AI-Workshop18-easy-peasy.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'April 2024',
    source: '/images/about-us/AI-Workshop1-easy-peasy.jpg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'April 2024',
    source: '/images/about-us/Workshop1-1-1.jpg',
  },
  {
    title: 'Agentic AI with Google',
    size: 'June 2025',
    source: '/images/about-us/easy-peasy.ai-google-june25.jpg',
  },
  {
    title: 'Agentic AI with Google',
    size: 'June 2025',
    source: '/images/about-us/easy-peasy.ai-google2-june25.jpg',
  },
  {
    title: 'Agentic AI with Google',
    size: 'June 2025',
    source: '/images/about-us/easy-peasy.ai-google3-june25.jpg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'June 2025',
    source: '/images/about-us/easy-peasy.ai-workshop-june25-2.jpg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'June 2025',
    source: '/images/about-us/easy-peasy.ai-workshop-june25.jpg',
  },
  {
    title: 'Generative AI with Addison Institute',
    size: 'March 2025',
    source: '/images/about-us/easy-peasy.ai-workshop-march25.jpg',
  },
  {
    title: 'Generative AI with Huttons Group',
    size: 'September 2025',
    source: '/images/about-us/huttons_workshop.JPG',
  },
  
  {
    title: 'Generative AI with CapitaLand',
    size: 'September 2025',
    source: '/images/about-us/IMG_6907.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'October 2025',
    source: '/images/about-us/Workshop47.jpeg',
  },
  {
    title: 'How To Make AI Work For You',
    size: 'March 2025',
    source: '/images/about-us/easy-peasy.ai-workshop-march3.jpg',
  },
 
 
];

export default function ImagesWithDetails() {
  return (
    <div className='pt-18 bg-white pb-12 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <h2 className='mx-auto mt-2 max-w-3xl text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
          Innovation in Focus
        </h2>
        <p className='mx-auto mt-5 max-w-prose text-center text-xl text-gray-500 dark:text-slate-400'>
          Explore our collection of vibrant images that capture the energy and
          creativity of our workshops.
        </p>

        <ul
          role='list'
          className='mt-12 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 sm:gap-x-6 xl:grid-cols-4 xl:gap-x-8'
        >
          {files.map((file) => (
            <li key={file.source} className='relative'>
              <div className='group block h-60 w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'>
                <Image
                  src={file.source}
                  alt=''
                  className='pointer-events-none h-full w-full object-cover group-hover:opacity-75'
                  width={600}
                  height={600}
                />
                <button
                  type='button'
                  className='absolute inset-0 focus:outline-none'
                >
                  <span className='sr-only'>View details for {file.title}</span>
                </button>
              </div>
              <p className='pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900 dark:text-slate-200'>
                {file.title}
              </p>
              <p className='pointer-events-none block text-sm font-medium text-gray-500 dark:text-slate-400'>
                {file.size}
              </p>
            </li>
          ))}
        </ul>
      </div>
      {/* <div className='flex justify-center pt-16'>
        <a
          href='https://easy-peasy-ai.getrewardful.com/signup'
          target='_blank'
          className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
          rel='noreferrer'
        >
          See More Here <span aria-hidden='true'>&rarr;</span>
        </a>
      </div> */}
    </div>
  );
}
